module.exports = __webpack_public_path__ + "img/2.6370404a.jpg";